import { jwtDecode }from "jwt-decode";
import { AuthAPI } from "../api/api";

export const saveToken = (token) => localStorage.setItem("token", token);
export const getToken = () => localStorage.getItem("token");
export const removeToken = () => localStorage.removeItem("token");

export const isLoggedIn = () => {
  const token = getToken();
  if (!token) return false;

  try {
    const { exp } = jwtDecode(token);
    if (!exp) return false;
    return Date.now() < exp * 1000;
  } catch {
    return false;
  }
};

export const getUserRole = () => {
  const token = getToken();
  if (!token) return null;

  try {
    const payload = jwtDecode(token);

    return payload.role || payload.roles || payload["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"] || null;
  } catch {
    return null;
  }
};

export async function isIpAllowed() {
  try {
    const res = await AuthAPI.checkIP();
    if (res.status !== 200) return false;
    const data = await res.data;
    return data.allowed === true;
  } catch {
    return false;
  }
}
